import { useRef, useState } from 'react';
import Checkbox from '../../components/options/Checkbox';
import IconStar from '../../components/options/IconStar';
import { useAuth } from '../../hooks/useAuth';

export default function HeroicInspiration({ characterId, value, onChange }: {
    characterId: number; value: boolean; onChange?: (value: boolean) => void;
}) {
    const { apiRequest } = useAuth();
    const [checked, setChecked] = useState(value);
    const [error, setError] = useState('');
    const queue = useRef<Promise<void>>(Promise.resolve());
    const save = (next: boolean) => {
        setChecked(next);
        setError('');
        queue.current = queue.current.then(async () => {
            try {
                await apiRequest(`/api/characters/${characterId}/inspiration`, 'PATCH', { value: next });
                onChange?.(next);
                setError('');
            } catch {
                setError('Could not save. Try again.');
            }
        });
    };
    return <section className="parchment-panel heroic-inspiration">
        <h2>Heroic Inspiration</h2>
        <Checkbox label="Heroic Inspiration" Icon={IconStar} checked={checked} onChange={save} size="1.75rem" />
        {error && <small role="alert">{error} <button type="button" onClick={() => save(checked)}>Retry</button></small>}
    </section>;
}
